import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import Swal from "sweetalert2";
import Select from "react-select";
import {
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Image
} from "react-bootstrap";
import { getMedicalCert, getSpecialLeaveAttachment } from "../../3.Store/ReviewLeaveApplicationSlice";
import { editLeaveApplication, getDaysApplying, getLeaveBalances, getLeaveApplicationDetails, resetForm, updateApplication } from "../../3.Store/ApplicationSlice";
import { LeaveType, LeaveNumberDay, Location, SpecialLeaveTypeOption } from "../../2.Commons/DropdownOption";
import { ThreeDots } from 'react-loader-spinner';
import { ApproveLeave, RejectLeave, RevokeLeave, resetList } from "../../3.Store/LeaveApprovalSlice";
import PDFViewer from "../../2.Commons/PDFViewer";
import DatePicker from "react-datepicker";

const LeaveApprovalForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const cert = useSelector(state => state.ReviewLeaveApplicationSlice.cert);
  const special_attachment = useSelector(state => state.ReviewLeaveApplicationSlice.special_attachment);
  const [loading, setLoading] = useState(false);
  const loading2 = useSelector(state => state.ApplicationSlice.loading);
  const [showBalance, setShowBalance] = useState("");
  const { application, balance, applying } = useSelector(
    (state) => state.ApplicationSlice
  );
  const [originalLeaveTypeId, setOriginalLeaveTypeId] = useState(null);
  const [originalDaysApplied, setOriginalDaysApplied] = useState(0);

  console.log(application);
  console.log("Balance:", balance);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchLeaveDetails = async () => {
      if (id) {
        try {
          console.log("Fetching leave details for ID:", id);
          const detail = await dispatch(getLeaveApplicationDetails({ id })).unwrap();
          // Always get the current balance
          if (detail) {
            // Save original info for balance calculation
            setOriginalLeaveTypeId(detail.leave_type?.id ?? null);
            setOriginalDaysApplied(Number(detail.number_of_days ?? 0));
            dispatch(getLeaveBalances({ id: detail.employee.id }));
            console.log("Fetched leave details:", detail);
          }
        } catch (error) {
          console.error("Failed to fetch leave details:", error);
        }
      }
    };
    fetchLeaveDetails();
  }, [id]);

  const appendTime = (date, ampm) => {
    return ampm === "AM" ? `${date} 08:00:00` : `${date} 13:00:00`;
  };
    
  const handleMCase = async (from_date, to_date, from_ampm, to_ampm) => {
    const fromDateString = appendTime(moment(from_date.date).format("YYYY-MM-DD"), from_ampm);
    const toDateString = appendTime(moment(to_date.date).format("YYYY-MM-DD"), to_ampm);
  
    const entity = {
      ...applying,
      employee: { id: application.employee.id },
      from_datetime: fromDateString,
      leave_type: { id: application.leave_type.id },
      to_datetime: toDateString
    };
  
    try {
      const updatedDaysApply = await dispatch(getDaysApplying(entity));
  
      const days_applying = { ...application, 
        number_of_days: updatedDaysApply.payload,
        from_ampm: from_ampm,
        to_ampm: to_ampm,
        from_date: from_date,
        to_date: to_date,
        current_balance: showBalance
      };
      console.log(days_applying);
      await dispatch(updateApplication(days_applying));
  
      if (["SP", "A", "SI"].includes(application?.leave_type?.id)) {
        let balanceAfterChange;
  
        if (!id) {
          balanceAfterChange = Number(showBalance) - Number(updatedDaysApply.payload);
        } else {
          if (showBalance !== 0 && originalDaysApplied !== 0) {
            balanceAfterChange =
              Number(showBalance) + Number(originalDaysApplied) - Number(application.number_of_days);
          }
        }
  
        if (balanceAfterChange < -5) {
          Swal.fire({
            title: "Leave Balance Insufficient!",
            text: "Do not have enough leave balance.",
            icon: "warning",
            button: "OK",
          });
        }
      }
    } catch (error) {
      console.error("Error updating days applying:", error);
    }
  };  

  useEffect(() => {
    // Function to fetch data based on leave type
    const fetchData = async () => {
      try {
        if (application.leave_type.id === "SI") {
          await dispatch(getMedicalCert({ id }));
        } else if (application?.leave_type?.id === "SP") {
          await dispatch(getSpecialLeaveAttachment({ id }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [application?.leave_type?.id]);

  // useEffect(() => {
  //   showBalanceAfter();
  // }, [balance, application?.leave_type?.id, application?.status?.id, application?.number_of_days]);

  // const showBalanceAfter = () => {
  //   const leaveTypeId = application?.leave_type?.id;
  //   const daysApplied = Number(application.number_of_days ?? 0);
  //   const status = application?.status?.id;

  //   // 1️⃣ Get current balance by leave type
  //   let currentBalance = 0;

  //   switch (leaveTypeId) {
  //     case "A":
  //       currentBalance = Number(balance?.annual ?? 0);
  //       break;
  //     case "AD":
  //       currentBalance = Number(balance?.advanced ?? 0);
  //       break;
  //     case "H":
  //       currentBalance = Number(balance?.hospitalization ?? 0);
  //       break;
  //     case "M":
  //       currentBalance = Number(balance?.maternity ?? 0);
  //       break;
  //     case "SI":
  //       currentBalance = Number(balance?.sick ?? 0);
  //       break;
  //     case "SP":
  //       currentBalance = Number(balance?.special ?? 0);
  //       break;
  //     case "O":
  //     case "UP":
  //       currentBalance = 0;
  //       break;
  //     default:
  //       currentBalance = 0;
  //   }

  //   // 2️⃣ Apply rule
  //   if (status === 100 && Number(application.current_balance) == 0 && (leaveTypeId !== "O" && leaveTypeId !== "UP")) {
  //     console.log(application.current_balance);
  //     setShowBalance(currentBalance + daysApplied);
  //   } else {
  //     console.log(application.current_balance);
  //     setShowBalance(application.current_balance);
  //   }
  // };

  useEffect(() => {
    showBalanceAfter();
  }, [balance, application?.leave_type?.id]);

  const showBalanceAfter = () => {
    const leaveTypeId = application?.leave_type?.id;
    const daysApplied = Number(application.number_of_days ?? 0);
    const status = application?.status?.id;

    // 1️⃣ Get current balance by leave type
    let currentBalance = 0;

    switch (leaveTypeId) {
      case "A":
        currentBalance = Number(balance?.annual ?? 0);
        break;
      case "AD":
        currentBalance = Number(balance?.advanced ?? 0);
        break;
      case "H":
        currentBalance = Number(balance?.hospitalization ?? 0);
        break;
      case "M":
        currentBalance = Number(balance?.maternity ?? 0);
        break;
      case "SI":
        currentBalance = Number(balance?.sick ?? 0);
        break;
      case "SP":
        currentBalance = Number(balance?.special ?? 0);
        break;
      case "O":
      case "UP":
        currentBalance = 0;
        break;
      default:
        currentBalance = 0;
    }

    // 2️⃣ Apply rule
    if (status === 100 && Number(application.current_balance) == 0 && (leaveTypeId !== "O" && leaveTypeId !== "UP")) {
      // console.log(application.current_balance);
      setShowBalance(currentBalance);
      // setShowBalance(currentBalance + daysApplied);
    } else {
      // console.log(application.current_balance);
      setShowBalance(currentBalance);
      // setShowBalance(application.current_balance);
    }
  };

  const handleBtnBack = () => {
    dispatch(resetList());
    dispatch(resetForm());
    navigate(-1);
  };

  const handleBtnRevoke = () => {
    Swal.fire({
      title: 'Do you want to change the status back to Pending?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        
        dispatch(RevokeLeave([id]))
          .unwrap()
          .then(() => {
            Swal.fire("Leave Application Reverted", "", "success", "OK").then(() => {
              navigate(`/LeaveApprovalList`);
            })
          })
          .catch((err) => {
            Swal.fire("Error", err.response?.data || 'An error occurred', "error", "OK");
          })
          .finally(() => {
            setLoading(false);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Revoke action has been cancelled.',
          'error'
        );
      }
    });
  };  

  const handleBtnReject = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        
        const entity = { ...application, to_date: { date: application.to_date.date }, current_balance: showBalance };
        
        dispatch(editLeaveApplication(entity))
          .unwrap()
          .then(() => {
            return dispatch(RejectLeave([id])).unwrap();
          })
          .then(() => {
            Swal.fire("Leave Application Rejected", "", "success", "OK").then(() => {
              navigate(`/LeaveApprovalList`);
            })
          })
          .catch((err) => {
            Swal.fire("Error", err.response?.data || 'An error occurred', "error", "OK");
          })
          .finally(() => {
            setLoading(false);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Rejection has been cancelled',
          'error'
        );
      }
    });
  };  

  const handleBtnApprove = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        
        const entity = { ...application, to_date: { date: application.to_date.date }, current_balance: showBalance };
        
        dispatch(editLeaveApplication(entity))
          .unwrap()
          .then(() => {
            return dispatch(ApproveLeave([id])).unwrap();
          })
          .then(() => {
            Swal.fire("Leave Application Approved", "", "success", "OK").then(() => {
              navigate(`/LeaveApprovalList`);
            })
          })
          .catch((err) => {
            Swal.fire("Error", err.response?.data || 'An error occurred', "error", "OK");
          })
          .finally(() => {
            setLoading(false);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Approval has been cancelled',
          'error'
        );
      }
    });
  };  

  const handleRemarkChange = (e) => {

    const text = e.target.value;
      
    // Detect NON-English characters (anything outside ASCII)
    const isNonEnglish = /[^\u0000-\u007F]/.test(text);
  
    if (isNonEnglish) {
      Swal.fire({
        text: "Only English is allowed. / Hanya Bahasa Inggeris dibenarkan.",
        icon: "warning",
        confirmButtonText: "OK",
      });
  
      // DO NOT update — keep previous correct value
      const entity = { ...application };
      console.log(entity);
      dispatch(updateApplication(entity));
  
      return; // stop further processing
    }
  
    // Normal valid update
    const entity = { ...application, remark: text };
    console.log(entity);
    dispatch(updateApplication(entity));
  };

  const handleChangeDropdownLeaveType = (value) => {
    console.log(value);
    const entity = {
      ...application,
      leave_type: {
        id: value.id,
      },
    };
    dispatch(updateApplication(entity));
    console.log(entity);
  };

  const handleChangeDropdownSpecialLeaveType = (value) => {
    console.log(value);
    const entity = {
      ...application,
      special_leave_type: {
        id: value.id,
      },
    };
    console.log(entity);
    dispatch(updateApplication(entity));
  };

  const handleChangeDropdownNumberOfDay = (value) => {
    console.log(value);
    const entity = {
      ...application,
      numberofday_type: {
        id: value.id,
      },
    };
    dispatch(updateApplication(entity));
    console.log(entity);
  };

  const handleChangeDropdownLocation = (value) => {
    console.log(value);
    const entity = {
      ...application,
      location_type: {
        id: value.id,
      },
    };
    dispatch(updateApplication(entity));
    console.log(entity);
  };

  const handleCheckForm = (e) => {
    const entity = { ...application, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateApplication(entity));

    // 👇 Only run when AM/PM fields change
    if (e.target.name === "from_ampm") {
      handleMCase(
        entity.from_date,
        entity.to_date,
        e.target.value,
        entity.to_ampm
      );
    }

    if (e.target.name === "to_ampm") {
      handleMCase(
        entity.from_date,
        entity.to_date,
        entity.from_ampm,
        e.target.value
      );
    }
  };

  const handleChangeFromDate = (e) => {
    const newFromDate = { date: e.target.value };
    const oldToDate = application.to_date;
  
    let correctedToDate = oldToDate;
  
    // If old to_date is earlier than new from_date → auto-correct it
    if (!oldToDate || moment(oldToDate.date).isBefore(moment(newFromDate.date))) {
      correctedToDate = newFromDate;
    }
  
    const entity = { 
      ...application, 
      from_date: newFromDate, 
      to_date: correctedToDate 
    };

    console.log(entity);
  
    dispatch(updateApplication(entity));
  
    handleMCase(newFromDate, correctedToDate, application.from_ampm, application.to_ampm);
  };

  const handleChangeToDate = (e) => {
    const newToDate = { date: e.target.value };
    const oldFromDate = application.from_date;

    let correctedFromDate = oldFromDate;

    // If new to_date is earlier than from_date → auto-correct from_date
    if (!oldFromDate || moment(newToDate.date).isBefore(moment(oldFromDate.date))) {
      correctedFromDate = newToDate;
    }

    const entity = {
      ...application,
      from_date: correctedFromDate,
      to_date: newToDate,
    };

    dispatch(updateApplication(entity));

    handleMCase(correctedFromDate, newToDate, application.from_ampm, application.to_ampm);
  };

  // Format the max date from details
  const maxFromDate = moment(application?.from_datetime?.date).format("YYYY-MM-DD");
  const maxToDate = moment(application?.to_datetime?.date).format("YYYY-MM-DD");

  return (
    <div className="container-sm">
      {(loading || loading2) && (
        <ThreeDots
          visible={(loading || loading2)}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Leave Approval</h1>
        <h1 className="MiniTitleHeader">View</h1>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Staff Name</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Form.Control value={application?.employee?.fullname} readOnly disabled/>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fw-normal fs-5">Leave Type</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            {application?.status?.id !== 100 ? (
              <Form.Control value={application?.leave_type?.description} readOnly disabled/>
            ) : (
              <Select
                name="leave_type"
                options={LeaveType}
                value={LeaveType.find(
                  (option) => option.id === application?.leave_type?.id
                )}
                onChange={handleChangeDropdownLeaveType}
              />
            )}
          </Col>
        </Row>

        {application?.leave_type?.id === "SI" && cert && cert.file && (
          <Row className="my-3">
            <Col md={12} sm={12} className="d-flex justify-content-center align-items-center">
              {/* Display image */}
              {cert.filetype.startsWith('image/') ? (
                <Image 
                  src={
                    cert.file.startsWith("data:")
                      ? cert.file
                      : `data:${cert.filetype};base64,${cert.file}`
                  }
                  alt="Uploaded file" 
                  fluid 
                />
              ) : (
                // Display PDF
                cert.file ? (
                  <div style={{ width: "100%" }}>
                    <PDFViewer base64Data={cert.file} height="500px" width="100%" />
                  </div>
                ) : (
                  <a href={`data:application/pdf;base64,${cert.file}`} download="attachment.pdf">
                    Download PDF
                  </a>
                )
                // <iframe
                //   src={`data:${cert.filetype};base64,${cert.file}`}
                //   title="PDF file"
                //   width="100%"
                //   height="500px"
                // ></iframe>
              )}
            </Col>
          </Row>
        )}

        {/* Special Leave */}
        {application?.leave_type?.id == "SP" && (
          <>
            <Row className="my-2">
              <Col md={8} sm={8}>
                <Form.Label className="FormLabel fw-normal fs-5">
                  Special Leave Type
                </Form.Label>
              </Col>
              <Col md={4} sm={4}>
                {application?.status?.id !== 100 ? (
                  <Form.Control value={application?.special_leave_type?.description} readOnly disabled/>
                ) : (
                  <Select
                    name="special_leave_type"
                    options={SpecialLeaveTypeOption}
                    value={SpecialLeaveTypeOption.find(
                      (option) => option.id === application?.special_leave_type?.id
                    )}
                    onChange={handleChangeDropdownSpecialLeaveType}
                  />
                )}
              </Col>
            </Row>
          </>
        )}

        {application?.leave_type?.id === "SP" && special_attachment && special_attachment.file && (
          <Row className="my-3">
            <Col md={12} sm={12} className="d-flex justify-content-center align-items-center">
              {/* Display image */}
              {special_attachment.filetype.startsWith('image/') ? (
                <Image 
                  src={
                    special_attachment.file.startsWith("data:")
                      ? special_attachment.file
                      : `data:${special_attachment.filetype};base64,${special_attachment.file}`
                  }
                  alt="Uploaded file" 
                  fluid 
                />
              ) : (
                // Display PDF
                special_attachment.file ? (
                  <div style={{ width: "100%" }}>
                    <PDFViewer base64Data={special_attachment.file} height="500px" width="100%" />
                  </div>
                ) : (
                  <a href={`data:application/pdf;base64,${special_attachment.file}`} download="attachment.pdf">
                    Download PDF
                  </a>
                )
                // <iframe
                //   src={`data:${special_attachment.filetype};base64,${special_attachment.file}`}
                //   title="PDF file"
                //   width="100%"
                //   height="500px"
                // ></iframe>
              )}
            </Col>
          </Row>
        )}

        <Row className="my-2">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fw-normal fs-5">No. of Days</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            {application?.status?.id !== 100 ? (
              <Form.Control value={application?.numberofday_type?.description} readOnly disabled/>
            ) : (
              <Select
                options={LeaveNumberDay}
                value={LeaveNumberDay.find(
                  (option) => option.id === application?.numberofday_type?.id
                )}
                onChange={handleChangeDropdownNumberOfDay}
              />
            )}
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={4}>
            <Form.Label className="FormLabel fw-normal fs-5">From</Form.Label>
          </Col>
          <Col md={2} sm={4}>
            <Form.Check 
              type="radio"
              label="AM" 
              name="from_ampm"
              value="AM"
              checked={application?.from_ampm == "AM"} 
              style={{ color: "#fff" }} 
              onChange={handleCheckForm}
              disabled={application?.status?.id !== 100}
            />
            <Form.Check 
              type="radio"
              label="PM" 
              value="PM"
              name="from_ampm"
              checked={application?.from_ampm == "PM"} 
              style={{ color: "#fff" }} 
              onChange={handleCheckForm}
              disabled={application?.status?.id !== 100}
            />
          </Col>
          <Col md={4} sm={4}>
            <DatePicker
              selected={application?.from_date?.date ? new Date(application?.from_date?.date) : null}
              onChange={(date) =>
                handleChangeFromDate({
                  target: {
                    // name: "from_date",
                    value: moment(date).format("YYYY-MM-DD"),
                  },
                })
              }
              minDate={maxFromDate}
              maxDate={maxToDate}
              dateFormat="yyyy-MM-dd"
              className={`form-control w-100 datepicker-icon`}
              disabled={application?.status?.id !== 100}
            />
          </Col>
        </Row>
       
        <Row className="my-2">
          <Col md={6} sm={4}>
            <Form.Label className="FormLabel fw-normal fs-5">To</Form.Label>
          </Col>
          <Col md={2} sm={4}>
            <Form.Check 
              type="radio"
              label="AM" 
              checked={application?.to_ampm == "AM"} 
              style={{ color: "#fff" }} 
              name="to_ampm"
              value="AM"
              onChange={handleCheckForm}
              disabled={application?.status?.id !== 100}
            />
            <Form.Check 
              type="radio"
              label="PM" 
              checked={application?.to_ampm == "PM"} 
              style={{ color: "#fff" }} 
              name="to_ampm"
              value="PM"
              onChange={handleCheckForm}
              disabled={application?.status?.id !== 100}
            />
          </Col>
          <Col md={4} sm={4}>
            <DatePicker
              selected={application?.to_date?.date ? new Date(application?.to_date?.date) : null}
              onChange={(date) =>
                handleChangeToDate({
                  target: {
                    // name: "from_date",
                    value: moment(date).format("YYYY-MM-DD"),
                  },
                })
              }
              minDate={maxFromDate}
              maxDate={maxToDate}
              dateFormat="yyyy-MM-dd"
              className={`form-control w-100 datepicker-icon`}
              disabled={application?.status?.id !== 100}
            />
          </Col>
        </Row>
        
        {application?.leave_type?.id !== "O" && application?.leave_type?.id !== "UP" && (
          <Row className="my-3">
            <Col md={8} sm={8}>
              <Form.Label className="FormLabel fw-normal fs-5">Leave Balance</Form.Label>
            </Col>
            <Col md={4} sm={4}>
              <Form.Control 
                // value={showBalance + Number(application?.number_of_days)} 
                value={
                  Number(application?.current_balance || 0) === 0
                    ? showBalance
                    : Number(application?.current_balance)
                }
                readOnly disabled
              />
            </Col>
          </Row>
        )}

        <Row className="my-2">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fw-normal fs-5">No. Days Applying</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            <Form.Control value={application?.number_of_days} readOnly disabled/>
          </Col>
        </Row>

        {/* {application?.leave_type?.id !== "O" && application?.leave_type?.id !== "UP" && (
          <Row className="my-3">
            <Col md={8} sm={8}>
              <Form.Label className="FormLabel fw-normal fs-5">Leave Balance After Approved / Rejected</Form.Label>
            </Col>
            <Col md={4} sm={4}>
              <Form.Control value={showBalance} readOnly disabled/>
            </Col>
          </Row>
        )} */}

        <Row className="my-3">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fw-normal fs-5">Location</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            {application?.status?.id !== 100 ? (
              <Form.Control value={application?.location_type?.description} readOnly disabled/>
            ) : (
              <Select
                options={Location}
                value={Location.find(
                  (option) => option.id === application?.location_type?.id
                )}
                onChange={handleChangeDropdownLocation}
              />
            )}
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={8} sm={8}>
            <Form.Label className="FormLabel fw-normal fs-5">Status</Form.Label>
          </Col>
          <Col md={4} sm={4}>
            <Form.Control value={application?.status?.description} readOnly disabled/>
          </Col>
        </Row>
        
        <Row className="my-2">
          <Col md={12} sm={12}>
            <Form.Label className="FormLabel fw-normal fs-5">Reason</Form.Label>
            <Form.Control as="textarea" value={application?.reason_for_application} readOnly disabled/>
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={12} sm={12}>
            <Form.Label className="FormLabel fw-normal fs-5">Description</Form.Label>
            <Form.Control as="textarea" value={application?.description} readOnly disabled/>
          </Col>
        </Row>

        <Row className="my-2">
          <Col md={12} sm={12}>
            <Form.Label className="FormLabel fw-normal fs-5">Remark</Form.Label>
            <Form.Control as="textarea" value={application?.remark || ""} onChange={handleRemarkChange}/>
          </Col>
        </Row>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>

          <ButtonGroup className="my-2">
            {[200, -501].includes(application?.status?.id) && (
              <Button className="Button" onClick={handleBtnRevoke}>
                Revoke
              </Button>
            )}
            &nbsp; &nbsp;
            <Button className="Button" onClick={handleBtnReject} disabled={application?.status?.id !== 100}>
              Reject
            </Button>
            &nbsp; &nbsp;
            <Button className="Button" onClick={handleBtnApprove} disabled={application?.status?.id !== 100}>
              Approve
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};
export default LeaveApprovalForm;
